import { IItem, instanceOfIItem } from "./IItem";
import { RelationalActionParameter } from "./RelationalActionParameter";

export interface IDateLinkApplicable extends IItem {
  isDateLinkKeyMatch(parameter: RelationalActionParameter): boolean;
  applyDate(date: Date): void;
}

export function instanceOfIDateLinkApplicable(instance: any): instance is IDateLinkApplicable {
  if (!instance) { return false; }
  return (instance.isDateLinkKeyMatch !== undefined)
    && (instance.applyDate !== undefined)
    && instanceOfIItem(instance);
}
